import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { FormControlLabelProps } from '@mui/material'
import SwitchCustom from '../Switches/SwitchCustom'

interface SwitchControllerProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label: string
  disabled?: boolean
  labelProps?: Omit<FormControlLabelProps, 'control' | 'label'>
}

export const SwitchController = <T extends FieldValues>({
  control,
  name,
  label,
  disabled = false,
  labelProps
}: SwitchControllerProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <SwitchCustom
          title={label}
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          label={label}
          {...labelProps}
        />
      )}
    />
  )
}
